import {
	connect
} from 'react-redux'
import DataTable from '../components/common/DataTable.jsx';
import {
	findFittingList,
	changeFittingActivePage, 
	deleteOrderer, 
	openFittingOrdererModal, 
	findOrderer
} from '../actions';

const mapStateToProps = (state) => ({
	orderId: state.getIn(['fittingReducer', 'orderId']),
	data: state.getIn(['fittingListReducer', 'fittingList']),
	activePage: state.getIn(['fittingListReducer', 'activePage']),
	itemPerPage: state.getIn(['fittingListReducer', 'itemPerPage']),
	totalPage: state.getIn(['fittingListReducer', 'totalPage']),
	searchWord: state.getIn(['fittingListReducer', 'searchWord']),
	pagingMaxButtons: 5,
	fields: {
		orderer_id: 'ID',
		display_name: '警義消別',
		category: '群組',
		firefighter_division: '大隊',
		firefighter_squadron: '分隊',
		firefighter_title: '職稱',
		firefighter_name: '姓名'
	},
    keys: ['suit_id', 'orderer_id'],
	searchKeys:[
		'firefighter_gear_orderers.category', 
		'firefighter_gear_orderers.firefighter_name',
		'firefighter_gear_orderers.firefighter_division',
		'firefighter_gear_orderers.firefighter_squadron', 
		'firefighter_gear_orderers.orderer_id' ],
    showCheckBox:true
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	refresh: (pagingData) => {
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData));
	},
	changeActivepage: (pagingData, searchData) => {
		dispatch(changeFittingActivePage(pagingData));
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData, searchData));
	},
	deleteItems:(deleteKey, pagingData) => {
		dispatch(deleteOrderer({orderId: ownProps.orderId}, deleteKey, pagingData));
	},
	openAddModal:() => {
		dispatch(openFittingOrdererModal({forInsert:true}));
	},
	handleEdit:(pk) => {
		dispatch(findOrderer({orderId: ownProps.orderId}, pk));
		dispatch(openFittingOrdererModal({forInsert:false}));
	},
	search:(pagingData, searchData) => {
		dispatch(findFittingList({orderId: ownProps.orderId}, pagingData, searchData));
	}
})

const FittingOrdererListContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DataTable)

export default FittingOrdererListContainer;


// WEBPACK FOOTER //
// ./src/containers/FittingOrdererListContainer.jsx